export const SUPPORT_EMAIL = process.env.NEXT_PUBLIC_SUPPORT_EMAIL || 'hello@tallyhealth.com';
export const CONTACT_URL =
  process.env.NEXT_PUBLIC_CONTACT_URL || 'https://support.tallyhealth.com/en-US/contact';

export const MAIN_CONTENT_NODE_ID = 'main';
